import * as $ from 'jquery';
import * as variables from '../../variables.js';

import Debouncer from '../../lib/Debouncer';
import DetectBrowser from '../../lib/DetectBrowser';
import ViewportTracker from '../../lib/ViewportTracker';

export default class InternetPlans {
	private wrapperEl: JQuery = $('.internetPlans');
	private targetEls: JQuery = $('.internetPlan__description');
	private triggerEls: JQuery;

	private createTriggers() {
		return $('<button>View Details</button>').insertAfter(this.targetEls);
	}
	private setupTriggers(): void {
		this.triggerEls = this.createTriggers();
		this.createTriggersEventHandlers();
	}
	private createTriggersEventHandlers(): void {
		this.triggerEls.on('click', (event:any) => {
			const currentText = $(event.currentTarget).text();
			$(event.currentTarget)
				.text( currentText == 'View Details' ? 'Hide Details' : 'View Details' )
				.prev()
				.slideToggle();
		});
	}
	private collapseDescription() {
		$(event.currentTarget).prev().slideToggle();
	}
	private expandDescription() {
	}
	private syncToViewport() {
		// Turn mobile menu on/off based on size
		if (ViewportTracker.below('internetPlanStack', true)) {
			this.targetEls.slideUp(0);
		} else {
			this.targetEls.slideDown(0);
		}
	}

	constructor() {
		if (!this.wrapperEl) {
			return;
		}
		this.setupTriggers();

		const resizeDebouncer = new Debouncer(() => {
			this.syncToViewport();
		});
		window.addEventListener('resize', resizeDebouncer.run);
		this.syncToViewport();
	}
}
